import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { getActCamionesExpCereal } from '../../../actions'
import { actualizarTablaCDMDExpCereal } from '../actions/TablaCamionesEnCircuitoActions'
import CamionesEnCircuitoExpCerealView from '../components/CamionesEnCircuitoPorExpCerealView'

function CamionesEnCircuitoPorExpCereal (props) {
  const { actualizarTablaCDMDExpCereal } = props

  useEffect(() => {
    actualizarTablaCDMDExpCereal()
  }, [actualizarTablaCDMDExpCereal])

  return (
    <>
      <CamionesEnCircuitoExpCerealView />
    </>
  )
}

const mapActionsToProps = {
  actualizarTablaCDMDExpCereal,
  getActCamionesExpCereal
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(CamionesEnCircuitoPorExpCereal)
